/* @ngInject */
const myWagonRevision = (
  $$wagon
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      enableValidator: '=?',
    },
    template: require('./myWagonRevision.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$wagon.metadata.fields

      $scope.revisionRadios = [{
        label: 'Aucune',
        id: '0M',
        value: 0,
      }, {
        label: '+3M',
        id: '3M',
        value: 3,
      }, {
        label: '+11M',
        id: '11M',
        value: 11,
      },]

      if (!$scope.enableValidator) {
        $scope.revisionRadios.unshift({
          label: 'Tous',
          id: 'never',
          value: null,
        },)
      }
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myWagonRevision



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/inputs/myWagonRevision.js